import React from "react";
import homeIcon from "../../assets/images/footer/home.svg";
import mailIcon from "../../assets/images/footer/mail.svg";
import phoneIcon from "../../assets/images/footer/phone.svg";

function ContactInformation() {
  return (
    <div className="py-8 pl-4 order-2 2xl:order-1 mx-auto 2xl:mx-0">
      <ul className="lg:flex lg:space-x-12 2xl:space-x-0 2xl:flex-col text-lg text-slate-700 font-light">
        <li className="py-2">
          <img className="hidden sm:inline h-8 pb-1 mr-3 opacity-60" src={homeIcon} alt="location" />
          Glasgow, UK
        </li>
        <li className="py-2">
          <img className="hidden sm:inline h-8 pb-1 mr-3 opacity-60" src={mailIcon} alt="email" />
          ada.arek@wp.pl
        </li>
        <li className="py-2">
          <img className="hidden sm:inline h-8 pb-1 mr-3 opacity-60" src={phoneIcon} alt="phone" />
          07936 885460
        </li>
      </ul>
    </div>
  )
}

export default ContactInformation;
